// extracted by mini-css-extract-plugin
export var Hr = "Layout-module--Hr--b7b08";
export var Wrapper = "Layout-module--Wrapper--7a70c";